"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _AccessoryFeaturesListComponent = _interopRequireDefault(require("./AccessoryFeaturesListComponent"));

var _constans = require("../../../../../configuration/constans");

var _reactRedux = require("react-redux");

var _utils = require("../../../../../configuration/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AccessoryItemComponent = function AccessoryItemComponent(_ref) {
  var accessory = _ref.accessory,
      index = _ref.index;
  var dictionary = (0, _reactRedux.useSelector)(function (state) {
    return state.dictionary;
  });
  return /*#__PURE__*/_react["default"].createElement("a", {
    href: dictionary.productDetailsPath + accessory.productId + _constans.initialState.accessoryParametr,
    className: "tab__content__section__row half",
    key: index,
    tabIndex: 5,
    onClick: function onClick(e) {
      return (0, _utils.sendDataLayerEvent)('Tab', "Accessories > ".concat(dictionary.productDetailsPath + accessory.productId));
    }
  }, (accessory === null || accessory === void 0 ? void 0 : accessory.images[0]) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "tab__content__section__row__image"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: accessory.images[0] ? (0, _utils.resolveImage)(accessory === null || accessory === void 0 ? void 0 : accessory.images[0], _constans.fastlyCompressionQuery.accessoriesTab) || '' : "",
    alt: accessory.filename,
    height: "216",
    width: "216"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tab__content__section__row__description"
  }, /*#__PURE__*/_react["default"].createElement(_AccessoryFeaturesListComponent["default"], {
    accessory: accessory
  })));
};

var _default = AccessoryItemComponent;
exports["default"] = _default;